import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBars,
  faCaretDown,
  faHamburger,
  faLanguage,
  faSliders,
  faFire,
  faHandHoldingCircleDollar as fassHandHoldingCircleDollar,
  faHeart as fassHeart,
  faArrowRight,
  faArrowLeft,
  faCircle,
  faCircleDot,
  faDollarSign,
  faDollarCircle,
  faStar,
  faBolt,
  faTag,
  faBell,
  faTrophy,
  faSparkles,
  faImage,
  faImageSlash,
  faSearch,
} from '@fortawesome/sharp-solid-svg-icons';

import {
  faHeart,
  faXmark,
  faShip,
  faCalendarDay,
  faCompass,
  faHandHoldingCircleDollar,
  faMessageDots,
  faInfoCircle,
  faQuestionCircle,
  faSquareCheck,
  faSquare,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  faLanguage,
  faHeart,
  faHamburger,
  faBars,
  faCaretDown,
  faSliders,
  fassHeart,
  faFire,
  faHandHoldingCircleDollar,
  faXmark,
  faShip,
  faCalendarDay,
  faCompass,
  faMessageDots,
  fassHandHoldingCircleDollar,
  faInfoCircle,
  faQuestionCircle,
  faArrowRight,
  faArrowLeft,
  faCircle,
  faCircleDot,
  faSquare,
  faSquareCheck,
  faDollarSign,
  faDollarCircle,
  faStar,
  faBolt,
  faTag,
  faBell,
  faTrophy,
  faSparkles,
  faImage,
  faImageSlash,
  faSearch
);
